import { gql } from '@apollo/client';
import { BRAND_BASIC_FRAGMENT } from './brandFragments';
import { PRODUCT_VARIANT_BASIC_FRAGMENT } from './productVariantFragments';

export const CATEGORY_BASIC_FRAGMENT = gql`
  fragment CategoryBasic on Category {
    id
    name
    slug
    description
    icon
    level
    isActive
    isInCatalog
    isBottom
    isPopular
    parent {
      id
      name
      slug
      icon
      level
      isActive
      isInCatalog
      isPopular
      isBottom
    }
    children(first: 100) {
      edges {
        node {
          id
          name
          slug
        }
      }
    }
  }
`;

export const CATEGORY_BASIC_WITH_TRANSLATION_FRAGMENT = gql`
  fragment CategoryTranslationBasic on Category {
    id
    name
    slug
    description
    icon
    level
    isActive
    isInCatalog
    isBottom
    isPopular
    translation(languageCode: $languageCode) {
      name
    }
    parent {
      id
      name
      slug
      icon
      level
      isActive
      isInCatalog
      isPopular
      isBottom
    }
  }
`;

export const CATEGORY_WITH_NESTED_CHILDREN_FRAGMENT = gql`
  fragment CategoryWithNestedChildren on Category {
    id
    name
    slug
    description
    icon
    level
    isActive
    isInCatalog
    isBottom
    isPopular
    seoTitle
    metaDescription
    translation(languageCode: $languageCode) {
      name
    }
    parent {
      id
      name
      slug
      icon
      level
      isActive
      isInCatalog
      isPopular
      isBottom
    }
    children(first: 50) {
      edges {
        node {
          id
          name
          slug
          icon
          level
          isActive
          isInCatalog
          isPopular
          isBottom
          translation(languageCode: $languageCode) {
            name
          }
          products(first: 4) {
            edges {
              node {
                ...ProductsBasicTranslated
                translation(languageCode: $languageCode) {
                  name
                }
              }
            }
          }
          children(first: 50) {
            edges {
              node {
                id
                name
                slug
                icon
                level
                isActive
                isInCatalog
                isPopular
                isBottom
                translation(languageCode: $languageCode) {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  fragment ProductsBasicTranslated on Product {
    id
    name
    slug
    brand {
      ...BrandBasic
    }
    category {
      ...CategoryTranslationBasic
    }
    rating
    isAvailable
    barcode
    thumbnail(size: 200) {
      url
      alt
    }
    defaultVariant {
      id
      name
      availability
      translation(languageCode: $languageCode) {
        name
      }
      media {
        id
        alt
        url(size: 3000)
      }
      pricing {
        price {
          net {
            currency
            amount
          }
        }
        percentageDiscountAmount
        priceUndiscounted {
          net {
            currency
            amount
          }
        }
        discount {
          net {
            currency
            amount
          }
        }
        installmentPrice4 {
          currency
          amount
        }
        installmentPrice6 {
          currency
          amount
        }
        installmentPrice12 {
          currency
          amount
        }
        bonusesAmount
      }
    }
    variants {
      id
      name
      availability
      translation(languageCode: $languageCode) {
        name
      }
      media {
        id
        alt
        url(size: 3000)
      }
      pricing {
        price {
          net {
            currency
            amount
          }
        }
        percentageDiscountAmount
        priceUndiscounted {
          net {
            currency
            amount
          }
        }
        discount {
          net {
            currency
            amount
          }
        }
        installmentPrice4 {
          currency
          amount
        }
        installmentPrice6 {
          currency
          amount
        }
        installmentPrice12 {
          currency
          amount
        }
        bonusesAmount
      }
    }
  }
  ${BRAND_BASIC_FRAGMENT}
  ${CATEGORY_BASIC_WITH_TRANSLATION_FRAGMENT}
`;

export const CATEGORY_WITH_NESTED_CHILDREN_SORT_BY_FRAGMENT = gql`
  fragment CategoryWithNestedChildrenSortBy on Category {
    id
    name
    slug
    description
    icon
    level
    isActive
    isInCatalog
    isBottom
    isPopular
    parent {
      id
      name
      slug
      icon
      level
      isActive
      isInCatalog
      isPopular
      isBottom
    }
    children(first: 50) {
      edges {
        node {
          id
          name
          slug
          icon
          level
          isActive
          isInCatalog
          isPopular
          isBottom
          products(first: 4, sortBy: $productSortBy) {
            edges {
              node {
                ...ProductsBasic
              }
            }
          }
          children(first: 50) {
            edges {
              node {
                id
                name
                slug
                icon
                level
                isActive
                isInCatalog
                isPopular
                isBottom
              }
            }
          }
        }
      }
    }
  }
  fragment ProductsBasic on Product {
    id
    name
    slug
    brand {
      ...BrandBasic
    }
    category {
      ...CategoryBasic
    }
    rating
    isAvailable
    barcode
    thumbnail(size: 200) {
      url
      alt
    }
    defaultVariant {
      ...ProductVariantBasic
    }
    variants {
      ...ProductVariantBasic
    }
  }
  ${BRAND_BASIC_FRAGMENT}
  ${CATEGORY_BASIC_FRAGMENT}
  ${PRODUCT_VARIANT_BASIC_FRAGMENT}
`;
